import { Button, TextField } from "@material-ui/core";
import React, { useCallback, useContext, useState } from "react";
import config from "react-global-configuration";
import { Redirect } from "react-router-dom";
import Backdrop from "../../components/Backdrop/Backdrop";
import Modal from "../../components/Modal/Modal";
import AuthContext from "../../context/auth-context";
import { store } from "../../store";

const AuthPage = (props) => {
	const authContext = useContext(AuthContext);
	const urlParams = new URLSearchParams(window.location.search);

	const [formData, SetFormData] = useState({ token: "" });
	const [formMessage, SetFormMessage] = useState();
	const [sendingForm, SetSendingForm] = useState(false);
	const [urlCheck, SetUrlCheck] = useState(false);

	// const [loginSuccess, SetLoginSuccess] = useState(false);
	// const [params, setParams] = useState(false);

	const doLogin = useCallback(() => {
		if (!sendingForm) {
			SetFormMessage("");
			const token =
				formData.token !== ""
					? formData.token
					: urlParams.get("pipedriveUserToken");

			if (token !== "") {
				const loginData = {
					pipedriveUserTokenCrypt: urlParams.get("pipedriveUserToken"),
					pipedriveUserToken: formData.token,
				};
				SetSendingForm(true);
				fetch(config.get("url_api") + "orcamento/loginNovo", {
					method: "POST",
					headers: {
						"Content-Type": "application/json;charset=utf-8",
					},
					body: JSON.stringify(loginData),
				})
					.then((res) => res.json())
					.then(
						(result) => {
							if (result.success) {
								authContext.login({
									token: result.pipedriveUserToken,
									userId: result.pipedriveUserData.id,
									name: result.pipedriveUserData.name,
								});
								if (
									urlParams.get("pipedriveDealId") &&
									urlParams.get("pipedriveDealId") !== ""
								) {
									let url =
										"/orcamento/criar?pipedriveDealId=" +
										urlParams.get("pipedriveDealId");

									if (urlParams.get("substituicaoId"))
										url += "&substituicaoId=" + urlParams.get("substituicaoId");

									if (urlParams.get("astec_chamado_id"))
										url +=
											"&astec_chamado_id=" + urlParams.get("astec_chamado_id");

									props.history.push(url);
								} else if (
									urlParams.get("orcamentoId") &&
									urlParams.get("orcamentoId") !== ""
								) {
									let url =
										"/orcamento/aceite?orcamentoId=" +
										urlParams.get("orcamentoId");

									if (urlParams.get("astec_chamado_id"))
										url +=
											"&astec_chamado_id=" + urlParams.get("astec_chamado_id");

									props.history.push(url);
								} else if (
									urlParams.get("cancelarId") &&
									urlParams.get("cancelarId") !== ""
								) {
									let url =
										"/orcamento/cancelar?cancelarId=" +
										urlParams.get("cancelarId");

									props.history.push(url);
								} else {
									props.history.push("/");
								}

								// SetLoginSuccess(true);
							} else {
								SetFormMessage(result.message);
								SetSendingForm(false);
								// SetLoginSuccess(false);
							}
						},
						(error) => {
							alert(error);
							SetSendingForm(false);
							// SetLoginSuccess(false);
						}
					);
			}
		}
	});

	if (!urlCheck && !sendingForm && urlParams.get("pipedriveUserToken")) {
		SetUrlCheck(true);
		doLogin();
	}

	return (
		<div className="modals">
			<Backdrop>
				<Modal title="Login" size="sm" onCancelTopo>
					{formMessage && <h3>{formMessage}</h3>}
					<TextField
						margin="dense"
						id="token"
						name="token"
						label="Token"
						autoComplete="off"
						fullWidth
						autoFocus
						value={formData && formData.token ? formData.token : ""}
						onChange={(e) => SetFormData({ token: e.target.value })}
						helperText="Cole o seu token do pipedrive"
					/>

					<Button
						variant="contained"
						color="primary"
						onClick={() => doLogin()}
						disabled={sendingForm}
					>
						{sendingForm ? "Aguarde..." : "ENVIAR"}
					</Button>
				</Modal>
			</Backdrop>
			{store.getState().authReducer.userId && <Redirect to="/orcmento" />}
		</div>
	);
};

export default AuthPage;
